import { Component, OnInit, ViewChild } from '@angular/core';
import { SessionService } from '../../services/session.service';
import { PlatformApiService } from '../../services/platform-api.service';
import { AdminAssessmentListComponent } from '../admin/assessment-list.component';
import { Assessment } from '../../models/AssessmentModel';

@Component({
  selector: 'app-assessment-template-dashboard',
  templateUrl: './assessment-template-dashboard.component.html',
  styleUrls: ['./assessment-template-dashboard.component.scss']
})
export class AssessmentTemplateDashboardComponent implements OnInit {
  state='LIST';
  selectedAssessmentTemplate: Assessment;

  @ViewChild(AdminAssessmentListComponent) assessmentTemplateList: AdminAssessmentListComponent;

  constructor(private _platformApi: PlatformApiService, public _sessionService: SessionService) { }

  ngOnInit() {
  }

  showAllAssessmentTemplates() {
    this.selectedAssessmentTemplate = undefined;
    this.state = 'LIST'
  }

  onStateChange(event) {
    switch(event.state) {
      case 'CREATE':
        this.selectedAssessmentTemplate = new Assessment();
        this.state = 'CREATE';
        break;
      case 'SELECT':
      case 'EDIT':
        this.selectedAssessmentTemplate = event.item;
        this.state = 'EDIT';
        break;
      case 'CREATESUCCESS':
      case 'EDITSUCCESS':
      case 'CREATECANCEL':
      case 'EDITCANCEL':
        this.selectedAssessmentTemplate = undefined;
        this.state = 'LIST';
        break;
    }
  }
}
